import * as types from '@/common/types/mutation.js'
// initial state
const state = {
  isLogin : false,
  token: '',
  user: ''
}

// getters
const getters = {
  isLogin: state => state.isLogin
}

// actions
const actions = {
  setLoginStatus(state) {

  }
}

// mutations
const mutations = {
  [types.LOGOUT](state) {
    state.isLogin = false;
  },
  [types.LOGIN](state) {
    state.isLogin = true;
  },
  [types.PUT_TOKEN] (state, tockenData) {
    state.token = tockenData
  },
  [types.CLEAR_TOKEN](state,tockenData) {
    state.token = ''
  },
  [types.PUT_USER] (state, userData) {
    state.user = userData
  },
  [types.CLEAR_USER](state,tockenData) {
    state.user = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
